export const analyticsData = (
  orgId: string,
  pageTitle: string,
  orgTitle: string,
  storyId: string,
) => {
  return `
        <script>
            window.eventLabel = "${orgId}";
            window.sendAnalyticsEvents = true;
            window.primaryVersionId = "{{system.primaryVersionId}}";
            window.analyticsData = {
                pageTitle: "{{system.pageTitle}}",
                versionTitle: "{{system.versionTitle}}",
                orgTitle: "${escapeQuotes(orgTitle)}",
                orgId: "${orgId}",
                storyId: "${storyId}",
                versionId: "{{system.versionId}}",
                versionCreatorId: "{{system.versionCreator}}",
                versionCreatedAt: "{{system.versionCreatedAt}}",
            };
        </script>
    `;
};

function escapeQuotes(unsafe: string): string {
  let isOpeningQuote = true;
  return unsafe.replace(/"/g, (match, offset, string) => {
    if (offset > 0 && string[offset - 1] === "\\") {
      return match;
    }
    const quote = isOpeningQuote ? "“" : "”";
    isOpeningQuote = !isOpeningQuote;
    return quote;
  });
}
